import { IServiceAnexo } from "./base/iServiceAnexo";

export default class ControleReclamacaoAnexoService extends IServiceAnexo {
    constructor() {
        super("ControleReclamacaoAnexo");
    }
}
